import React, { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
import { Col, Row, Container, Image } from "react-bootstrap";
import { Formik, Form, Field} from "formik";
import * as Yup from "yup";
import axios from "axios";

import Card from "../../components/Card/index";
import Title from "../../components/Title";
import Input from "../../components/Input/index";
import Button from "../../components/Button/index";
import ErrorMessage from "../../components/ErrorMessage";

import { Message, TitlePage } from "./styles";

//Assets
import Logo from "../../assets/img/logo.svg";

const NewPasswordPage = () => {
    const [error, setError] = useState(false);

    const [isEmailSended, setIsEmailSended] = useState(false);

    // const history = useHistory();

    useEffect(() => {
        document.body.classList.add("body-login");

        return () => {
            document.body.classList.remove("body-login");
        };
    }, []);

    const formValidationWithYup = Yup.object().shape({
        email: Yup.string().email().required()
    })

    return (
        <Container className="vh-100 d-flex align-items-center justify-content-center">
            <Row>
                <Col lg="12">
                    <Card>
                        <Container>
                            <Row>
                                <Col xl="12" className="text-center  pt-4">
                                    <Image src={Logo} style={{ height: 45 }} />
                                </Col>

                                <Col xl="12" className="text-center pt-5 ">
                                    <TitlePage>Esqueci minha senha</TitlePage>
                                </Col>
                                {
                                    !isEmailSended ? 
                                        <Formik 
                                            initialValues={{
                                                email: ""
                                            }}
                                            validationSchema={formValidationWithYup}
                                            onSubmit={async (values) => {
                                                try {
                                                    const {data} = await axios.post("https://api.100pay.org/password/forgot", {
                                                        email: values.email
                                                    });
                                                    
                                                    setIsEmailSended(true);
                                                } catch (e) {
                                                    setError(true)
                                                }
                                            }}

                                        >
                                            {() => {
                                                return (
                                                    <Form style={{width: "100%"}}>
                                                        <Col xl="12" className=" pt-3 ">
                                                            <Title>Digite o email cadastrado</Title>
                                                            <Field id="email" name="email" as={Input}/>
                                                        </Col>

                                                        <Col xl="12" className=" pt-5">
                                                            {
                                                                error ?
                                                                    <ErrorMessage>
                                                                        Email não identificado
                                                                    </ErrorMessage> : null
                                                            }
                                                            <Button type="submit" >Enviar</Button>
                                                        </Col>
                                                    </Form>
                                                )
                                            }}

                                        </Formik> :
                                        <>
                                            <Col xl="12" className="pt-4">
                                                <Message>
                                                    Não se preocupe, em breve você estará recebendo um email com um link para redefinir sua senha.
                                                </Message>
                                            </Col>
                                        </>
                                }
                                

                            </Row>
                        </Container>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default NewPasswordPage;